module.exports = __webpack_public_path__ + "willing-favicon.ico";